import { Button, Loader, Modal, ModalBody, ModalDialog, ModalFooter, ModalHeader } from '@ax/ui';
import styles from './PoorReviewResponseModal.module.scss';
import ToggleButton from '@/components/ToggleButton';
import { NoteReview } from '@ax/redux-store';
import {
  PoorReviewResponseReason,
  PoorReviewResponseReasonLabels,
  StateSliceStatus,
} from '@ax/constants';
import { useState } from 'react';
import useAnalytics from '@/hooks/useAnalytics.tsx';

export interface NoteReviewDetailedResponseModalProps {
  isOpen: boolean;
  onHide: () => void;
  onSubmit: (review: NoteReview) => void;
  review?: NoteReview;
  reviewStateStatus?: StateSliceStatus;
}

export default function PoorReviewResponseModal({
  isOpen,
  onHide,
  onSubmit,
  review = {},
  reviewStateStatus,
}: Readonly<NoteReviewDetailedResponseModalProps>) {
  const [poorReviewReasons, setPoorReviewReasons] = useState<string[]>([]);
  const [textResponse, setTextResponse] = useState<string>('');
  const analytics = useAnalytics();

  const handleToggleReason = (reason: string) => {
    const isRemoving = poorReviewReasons.includes(reason);

    setPoorReviewReasons((prevReasons) => {
      return isRemoving ? prevReasons.filter((r) => r !== reason) : [...prevReasons, reason];
    });

    if (isRemoving) {
      analytics.onNoteLevelFeedbackReasonRemoved({
        noteId: review.noteId,
        reason,
      });
    } else {
      analytics.onNoteLevelFeedbackReasonAdded({
        noteId: review.noteId,
        reason,
      });
    }
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextResponse(event.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      ...review,
      poorReviewReasons,
      textResponse,
    });
  };

  const isSubmitDisabled =
    reviewStateStatus === StateSliceStatus.Loading ||
    (poorReviewReasons.length === 0 && textResponse === '');

  return (
    <Modal
      className={styles.detailed_response_modal}
      onShow={isOpen}
    >
      <ModalDialog classNames={styles.detailed_response_modal__container}>
        <ModalHeader onHide={onHide}>
          <br />
          <br />
          <br />
          <center>
            <span className={styles.detailed_response_modal__main_title}>Note Feedback</span>
          </center>
          <br />
          <br />
        </ModalHeader>
        <ModalBody>
          <center>
            <div className={styles.detailed_response_modal__reasons_container}>
              {Object.keys(PoorReviewResponseReason).map((poorReviewReason) => (
                <ToggleButton
                  key={`poor-review-reason-${poorReviewReason}`}
                  label={PoorReviewResponseReasonLabels[poorReviewReason]}
                  value={poorReviewReason}
                  isActive={poorReviewReasons.includes(poorReviewReason)}
                  onToggle={(item) => handleToggleReason(item.value)}
                />
              ))}
            </div>
          </center>
          <br />
          <center>
            <span className={styles.detailed_response_modal__info_sub_title}>Tell us more</span>
          </center>
          <br />
          <textarea
            className={styles.detailed_response_modal__textarea}
            placeholder="Type response here..."
            onChange={handleTextChange}
          ></textarea>
          <ModalFooter>
            <Button
              className={styles.detailed_response_modal__btn}
              variant={'primary'}
              onClick={handleSubmit}
              disabled={isSubmitDisabled}
              type="button"
            >
              {reviewStateStatus === StateSliceStatus.Loading ? <Loader /> : <span>Submit</span>}
            </Button>
          </ModalFooter>
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
}
